import { Typography } from "@mui/material";
import { StyledContainer, StyledSadBrightbotIcon } from "./style";

const EmptySession = () => {
  return (
    <StyledContainer>
      <StyledSadBrightbotIcon />
      <Typography textAlign="center" variant="subtitle2">
        It's empty in here
      </Typography>
      <Typography textAlign="center" variant="subtitle2">
        Create new session
      </Typography>
    </StyledContainer>
  );
};

export default EmptySession;
